// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"iF-z","smallCardRow":"jF-z","largeCardRow":"kF-z","productSearchRow":"lF-z","curatedRow":"mF-z"};